// ┌─────────────────────────────────────────────┐
// │  AUTO-GENERATED — DO NOT EDIT               │
// │  Run `npm run routes` to regenerate          │
// └─────────────────────────────────────────────┘

import React from "react";

const load_Page_Home = () => import(/* webpackChunkName: "page-home" */ "../pages/Home");
const Page_Home = React.lazy(load_Page_Home);
const load_Page_404 = () => import(/* webpackChunkName: "page-404" */ "../pages/404");
const Page_404 = React.lazy(load_Page_404);
const load_Page_about_area_offices = () => import(/* webpackChunkName: "page-about-area-offices" */ "../pages/about/area-offices");
const Page_about_area_offices = React.lazy(load_Page_about_area_offices);
const load_Page_about_board_of_directors = () => import(/* webpackChunkName: "page-about-board-of-directors" */ "../pages/about/board-of-directors");
const Page_about_board_of_directors = React.lazy(load_Page_about_board_of_directors);
const load_Page_about_contractor_registration = () => import(/* webpackChunkName: "page-about-contractor-registration" */ "../pages/about/contractor-registration");
const Page_about_contractor_registration = React.lazy(load_Page_about_contractor_registration);
const load_Page_about_management_team = () => import(/* webpackChunkName: "page-about-management-team" */ "../pages/about/management-team");
const Page_about_management_team = React.lazy(load_Page_about_management_team);
const load_Page_about_our_company = () => import(/* webpackChunkName: "page-about-our-company" */ "../pages/about/our-company");
const Page_about_our_company = React.lazy(load_Page_about_our_company);
const load_Page_about_qhse_policy = () => import(/* webpackChunkName: "page-about-qhse-policy" */ "../pages/about/qhse-policy");
const Page_about_qhse_policy = React.lazy(load_Page_about_qhse_policy);
const load_Page_about_right_of_way = () => import(/* webpackChunkName: "page-about-right-of-way" */ "../pages/about/right-of-way");
const Page_about_right_of_way = React.lazy(load_Page_about_right_of_way);
const load_Page_customer_band_tariff = () => import(/* webpackChunkName: "page-customer-band-tariff" */ "../pages/customer/band-tariff");
const Page_customer_band_tariff = React.lazy(load_Page_customer_band_tariff);
const load_Page_customer_contact = () => import(/* webpackChunkName: "page-customer-contact" */ "../pages/customer/contact");
const Page_customer_contact = React.lazy(load_Page_customer_contact);
const load_Page_customer_faqs = () => import(/* webpackChunkName: "page-customer-faqs" */ "../pages/customer/faqs");
const Page_customer_faqs = React.lazy(load_Page_customer_faqs);
const load_Page_customer_fire_safety_tips = () => import(/* webpackChunkName: "page-customer-fire-safety-tips" */ "../pages/customer/fire-safety-tips");
const Page_customer_fire_safety_tips = React.lazy(load_Page_customer_fire_safety_tips);
const load_Page_customer_log_complaints = () => import(/* webpackChunkName: "page-customer-log-complaints" */ "../pages/customer/log-complaints");
const Page_customer_log_complaints = React.lazy(load_Page_customer_log_complaints);
const load_Page_customer_payment_offices = () => import(/* webpackChunkName: "page-customer-payment-offices" */ "../pages/customer/payment-offices");
const Page_customer_payment_offices = React.lazy(load_Page_customer_payment_offices);
const load_Page_customer_report_outage = () => import(/* webpackChunkName: "page-customer-report-outage" */ "../pages/customer/report-outage");
const Page_customer_report_outage = React.lazy(load_Page_customer_report_outage);
const load_Page_customer_rights = () => import(/* webpackChunkName: "page-customer-rights" */ "../pages/customer/rights");
const Page_customer_rights = React.lazy(load_Page_customer_rights);
const load_Page_customer_whistleblowing = () => import(/* webpackChunkName: "page-customer-whistleblowing" */ "../pages/customer/whistleblowing");
const Page_customer_whistleblowing = React.lazy(load_Page_customer_whistleblowing);
const load_Page_e_payment_centers = () => import(/* webpackChunkName: "page-e-payment-centers" */ "../pages/e-payment-centers");
const Page_e_payment_centers = React.lazy(load_Page_e_payment_centers);
const load_Page_legal_privacy_policy = () => import(/* webpackChunkName: "page-legal-privacy-policy" */ "../pages/legal/privacy-policy");
const Page_legal_privacy_policy = React.lazy(load_Page_legal_privacy_policy);
const load_Page_media_gallery = () => import(/* webpackChunkName: "page-media-gallery" */ "../pages/media/gallery");
const Page_media_gallery = React.lazy(load_Page_media_gallery);
const load_Page_media_general_information = () => import(/* webpackChunkName: "page-media-general-information" */ "../pages/media/general-information");
const Page_media_general_information = React.lazy(load_Page_media_general_information);
const load_Page_metering_map_prices = () => import(/* webpackChunkName: "page-metering-map-prices" */ "../pages/metering/map-prices");
const Page_metering_map_prices = React.lazy(load_Page_metering_map_prices);
const load_Page_metering_map_process = () => import(/* webpackChunkName: "page-metering-map-process" */ "../pages/metering/map-process");
const Page_metering_map_process = React.lazy(load_Page_metering_map_process);
const load_Page_metering_new_customer_connection = () => import(/* webpackChunkName: "page-metering-new-customer-connection" */ "../pages/metering/new-customer-connection");
const Page_metering_new_customer_connection = React.lazy(load_Page_metering_new_customer_connection);
const load_Page_metering_prepaid_meter_upgrade = () => import(/* webpackChunkName: "page-metering-prepaid-meter-upgrade" */ "../pages/metering/prepaid-meter-upgrade");
const Page_metering_prepaid_meter_upgrade = React.lazy(load_Page_metering_prepaid_meter_upgrade);
const load_Page_payment_callback = () => import(/* webpackChunkName: "page-payment-callback" */ "../pages/payment/callback");
const Page_payment_callback = React.lazy(load_Page_payment_callback);

export interface RouteDef {
	path: string;
	pattern: RegExp;
	keys: string[];
	component: React.ComponentType<any>;
	loading?: React.ComponentType<any>;
}

export const routes: RouteDef[] = [
	{
		path: "/",
		pattern: new RegExp("^\\/$"),
		keys: [],
		component: Page_Home
	},
	{
		path: "/404",
		pattern: new RegExp("^/404$"),
		keys: [],
		component: Page_404
	},
	{
		path: "/about/area-offices",
		pattern: new RegExp("^/about/area-offices$"),
		keys: [],
		component: Page_about_area_offices
	},
	{
		path: "/about/board-of-directors",
		pattern: new RegExp("^/about/board-of-directors$"),
		keys: [],
		component: Page_about_board_of_directors
	},
	{
		path: "/about/contractor-registration",
		pattern: new RegExp("^/about/contractor-registration$"),
		keys: [],
		component: Page_about_contractor_registration
	},
	{
		path: "/about/management-team",
		pattern: new RegExp("^/about/management-team$"),
		keys: [],
		component: Page_about_management_team
	},
	{
		path: "/about/our-company",
		pattern: new RegExp("^/about/our-company$"),
		keys: [],
		component: Page_about_our_company
	},
	{
		path: "/about/qhse-policy",
		pattern: new RegExp("^/about/qhse-policy$"),
		keys: [],
		component: Page_about_qhse_policy
	},
	{
		path: "/about/right-of-way",
		pattern: new RegExp("^/about/right-of-way$"),
		keys: [],
		component: Page_about_right_of_way
	},
	{
		path: "/customer/band-tariff",
		pattern: new RegExp("^/customer/band-tariff$"),
		keys: [],
		component: Page_customer_band_tariff
	},
	{
		path: "/customer/contact",
		pattern: new RegExp("^/customer/contact$"),
		keys: [],
		component: Page_customer_contact
	},
	{
		path: "/customer/faqs",
		pattern: new RegExp("^/customer/faqs$"),
		keys: [],
		component: Page_customer_faqs
	},
	{
		path: "/customer/fire-safety-tips",
		pattern: new RegExp("^/customer/fire-safety-tips$"),
		keys: [],
		component: Page_customer_fire_safety_tips
	},
	{
		path: "/customer/log-complaints",
		pattern: new RegExp("^/customer/log-complaints$"),
		keys: [],
		component: Page_customer_log_complaints
	},
	{
		path: "/customer/payment-offices",
		pattern: new RegExp("^/customer/payment-offices$"),
		keys: [],
		component: Page_customer_payment_offices
	},
	{
		path: "/customer/report-outage",
		pattern: new RegExp("^/customer/report-outage$"),
		keys: [],
		component: Page_customer_report_outage
	},
	{
		path: "/customer/rights",
		pattern: new RegExp("^/customer/rights$"),
		keys: [],
		component: Page_customer_rights
	},
	{
		path: "/customer/whistleblowing",
		pattern: new RegExp("^/customer/whistleblowing$"),
		keys: [],
		component: Page_customer_whistleblowing
	},
	{
		path: "/e-payment-centers",
		pattern: new RegExp("^/e-payment-centers$"),
		keys: [],
		component: Page_e_payment_centers
	},
	{
		path: "/legal/privacy-policy",
		pattern: new RegExp("^/legal/privacy-policy$"),
		keys: [],
		component: Page_legal_privacy_policy
	},
	{
		path: "/media/gallery",
		pattern: new RegExp("^/media/gallery$"),
		keys: [],
		component: Page_media_gallery
	},
	{
		path: "/media/general-information",
		pattern: new RegExp("^/media/general-information$"),
		keys: [],
		component: Page_media_general_information
	},
	{
		path: "/metering/map-prices",
		pattern: new RegExp("^/metering/map-prices$"),
		keys: [],
		component: Page_metering_map_prices
	},
	{
		path: "/metering/map-process",
		pattern: new RegExp("^/metering/map-process$"),
		keys: [],
		component: Page_metering_map_process
	},
	{
		path: "/metering/new-customer-connection",
		pattern: new RegExp("^/metering/new-customer-connection$"),
		keys: [],
		component: Page_metering_new_customer_connection
	},
	{
		path: "/metering/prepaid-meter-upgrade",
		pattern: new RegExp("^/metering/prepaid-meter-upgrade$"),
		keys: [],
		component: Page_metering_prepaid_meter_upgrade
	},
	{
		path: "/payment/callback",
		pattern: new RegExp("^/payment/callback$"),
		keys: [],
		component: Page_payment_callback
	}
];

import { DefaultApp } from "../pages/../shared/DefaultApp";
export const App = DefaultApp;





// Map routes to their dynamic-import loaders so Webpack resolves the real chunk URL.
export const routeChunkMap: Record<string, () => Promise<unknown>> = {
	"/": load_Page_Home,
	"/404": load_Page_404,
	"/about/area-offices": load_Page_about_area_offices,
	"/about/board-of-directors": load_Page_about_board_of_directors,
	"/about/contractor-registration": load_Page_about_contractor_registration,
	"/about/management-team": load_Page_about_management_team,
	"/about/our-company": load_Page_about_our_company,
	"/about/qhse-policy": load_Page_about_qhse_policy,
	"/about/right-of-way": load_Page_about_right_of_way,
	"/customer/band-tariff": load_Page_customer_band_tariff,
	"/customer/contact": load_Page_customer_contact,
	"/customer/faqs": load_Page_customer_faqs,
	"/customer/fire-safety-tips": load_Page_customer_fire_safety_tips,
	"/customer/log-complaints": load_Page_customer_log_complaints,
	"/customer/payment-offices": load_Page_customer_payment_offices,
	"/customer/report-outage": load_Page_customer_report_outage,
	"/customer/rights": load_Page_customer_rights,
	"/customer/whistleblowing": load_Page_customer_whistleblowing,
	"/e-payment-centers": load_Page_e_payment_centers,
	"/legal/privacy-policy": load_Page_legal_privacy_policy,
	"/media/gallery": load_Page_media_gallery,
	"/media/general-information": load_Page_media_general_information,
	"/metering/map-prices": load_Page_metering_map_prices,
	"/metering/map-process": load_Page_metering_map_process,
	"/metering/new-customer-connection": load_Page_metering_new_customer_connection,
	"/metering/prepaid-meter-upgrade": load_Page_metering_prepaid_meter_upgrade,
	"/payment/callback": load_Page_payment_callback,
};
